import React from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import { StdForm } from 'components'
import { DetailContainer, Cont, SContDetail } from './styled'
import { blItemColumns } from './data'

const Contract = (props) => {
  const { blDetail } = props
  const items = blDetail.billingContracts || []

  return (
    <StdForm showHeader={false} title='' >
      <DetailContainer>
        <Cont style={{ width: '100%' }}>
          <SContDetail>
            <ReactTable
              className='blItems'
              data={items}
              columns={blItemColumns}
              minRows={items.length > 10 ? 10 : items.length || 5}
              defaultPageSize={10}
              showPagination={items.length > 10}
            />
          </SContDetail>
        </Cont>
      </DetailContainer>
      <br />
    </StdForm>
  )
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Contract)